__turbopack_context__.v({
  "box": "menu-module-scss-module__kgDewW__box",
  "dash": "menu-module-scss-module__kgDewW__dash",
  "divider": "menu-module-scss-module__kgDewW__divider",
  "line": "menu-module-scss-module__kgDewW__line",
  "menu": "menu-module-scss-module__kgDewW__menu",
});
